var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 8C0.5 3.58172 4.08172 0 8.5 0C12.9183 0 16.5 3.58172 16.5 8C16.5 12.4183 12.9183 16 8.5 16C4.08172 16 0.5 12.4183 0.5 8Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 8L12.5 8",
    stroke: "#B5C1D0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 15C4.63401 15 1.5 11.866 1.5 8H-0.5C-0.5 12.9706 3.52944 17 8.5 17V15ZM15.5 8C15.5 11.866 12.366 15 8.5 15V17C13.4706 17 17.5 12.9706 17.5 8H15.5ZM8.5 1C12.366 1 15.5 4.13401 15.5 8H17.5C17.5 3.02944 13.4706 -1 8.5 -1V1ZM8.5 -1C3.52944 -1 -0.5 3.02944 -0.5 8H1.5C1.5 4.13401 4.63401 1 8.5 1V-1Z",
    fill: "#F0F0F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinus);
export default __webpack_public_path__ + "static/media/minus.679ae3f6b7c6af0c2689a22249356ebc.svg";
export { ForwardRef as ReactComponent };